import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

export const useDeleteManagementPlan = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (planId: string) => {
			try {
				await api.delete(`/management/plan/delete/${planId}`);
			} catch (error) {
				throw toApiError(error, 'Erro ao excluir plano');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['management-plans'] });
		},
	});
};
